<template>
  <Dialog
    v-model="dialogDeleteGeneral"
    icon="fas fa-trash-alt"
    :title="$t('COMFIRMATION')"
  >
    <template v-slot:content>削除します。よろしいですか。</template>
    <template v-slot:actions>
      <v-btn color @click="dialogDeleteGeneral = false" small>{{
        $t("CANCEL")
      }}</v-btn>
      <v-btn
        color="error"
        small
        :disabled="loadingDeleteGeneral"
        :loading="loadingDeleteGeneral"
        @click="handleDeleteItemGeneralExercises"
        >{{ $t("OK") }}</v-btn
      >
    </template>
  </Dialog>
</template>

<script>
import { deleteQuestion } from "@/api/Question.api";
import Dialog from "@/components/Dialog/Dialog";
export default {
  props: ["item"],
  components: { Dialog },
  data() {
    return {
      dialogDeleteGeneral: false,
      loadingDeleteGeneral: false,
    };
  },
  methods: {
    async handleDeleteItemGeneralExercises() {
      this.loadingDeleteGeneral = true;
      var parent = "";
      if (this.$route.name == "List General OF Season") {
        parent = "season";
      } else if (this.$route.name == "List General OF Chapter") {
        parent = "chapter";
      } else if (this.$route.name == "List General OF Section") {
        parent = "section";
      }
      let params = {
        id: this.item.Id,
        sub_key: this.$route.params[parent],
      };
      await deleteQuestion(params)
        .then(() => {
          this.$emit("resetList");
          this.loadingDeleteGeneral = false;
          this.dialogDeleteGeneral = false;
        })
        .catch(() => {
          this.loadingDeleteGeneral = false;
        });
    },
    handleCancel() {
      //   this.$emit("resetList");
      this.loadingDeleteGeneral = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>